module.exports = __webpack_public_path__ + "img/redacao_rascunho.a2d6710b.svg";